import { graphql } from '@/gql';
import type { UserInteractionsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedUserInteractionTypeResponse } from '@/models/userInteraction';

export const fetchUserInteractions = async ({
  id,
  changes,
  objectType,
  pagination,
}: UserInteractionsQueryVariables): Promise<PaginatedUserInteractionTypeResponse> => {
  const response = await queryExecute({
    variables: {
      id,
      changes,
      objectType,
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query UserInteractions($id: String!, $changes: String, $objectType: String, $pagination: PaginationInputType) {
        userInteractions(id: $id, changes: $changes, objectType: $objectType, pagination: $pagination) {
          count
          rows {
            id
            userId
            action
            associatedObjectId
            associatedObjectType
            user {
              firstName
              lastName
              role
            }
            callerAddressName
            changes
            url
            notes
            createdAt
            updatedAt
          }
        }
      }
    `),
  });

  return response.data.userInteractions;
};
